/*!
=========================================================

* Argon Dashboard React - v1.2.0

=========================================================

 

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

 

* Coded by Creative Tim

 

=========================================================

 

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 

*/

import React, { useState, useEffect, Component } from 'react';
import { NavLink as NavLinkRRD, Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
//import axios from "axios";
import axiosInstance from './../../helpers/axiosInstance';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Skeleton from 'react-loading-skeleton';
import iconDetails from '../../assets/img/icons/Icono-Detalles-Gris.png';
import iconTransfer from '../../assets/img/icons/Icono-Transferencia-Gris.png';
import iconPay from '../../assets/img/icons/Icono-Pago-Interno-Gris.png';
import iconProyect from '../../assets/img/icons/Icono-Deuda-Gris.png';
import iconDetailsRojo from '../../assets/img/icons/Icono-Detalles-Rojo.png';
import iconDetailsVerde from '../../assets/img/icons/Icono-Detalles-Verde.png';
import iconTransferRojo from '../../assets/img/icons/Icono-Transferencia-Rojo.png';
import iconTransferVerde from '../../assets/img/icons/Icono-Transferencia-Verde.png';
import iconPayVerde from '../../assets/img/icons/Icono-Pago-Interno-Verde.png';
import iconProyectVerde from '../../assets/img/icons/Icono-Deuda-Verde.png';
import Movimientoshome from './movimientoshome';
import basePerfiles from '../../views/siif/basePerfiles.js';
import Carruselproductos from './Carruselproductos';

// reactstrap components

import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from 'reactstrap';

import { useSelector, useDispatch } from 'react-redux';

import {
  cambiaruta,
  cambiasidebar,
  opcadmnav,
  actualizaIpyfecha,
  actualizarProducts,
  actualizaBalanceTotal,
  actualizaProductSelect,
  actualizaAlert,
} from '../../Slicersreducers';

const _ = require('lodash');

function Home() {
  let settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
  };
  const [perfiles, setperfiles] = useState(basePerfiles);
  const [sett, setSett] = useState(settings);
  const [ListProducts, setList] = useState([]);
  const [product, setProduct] = useState({});
  const [totalBalanceAccounts, setTotalBalanceAccounts] = useState(0);
  const [totalBalanceCredit, setTotalBalanceCredit] = useState(0);
  const [totalBalanceCDTs, setTotalBalanceCDTs] = useState(0);
  const [listMovements, setListMovements] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isMovementLoading, setIsMovementLoading] = useState(true);
  const [permisos, setpermisos] = useState([
    {
      title: 'Transferir',

      habil: false,
    },
  ]);
  const [shortCutAccountFilter, setShortCutAccountFilter] = useState();
  const [DateLastLog, setDateLastLog] = useState();
  const ipredux = useSelector((state) => state.miga.ultimaip);
  const fechaingresoredux = useSelector((state) => state.miga.fechultingreso);
  const [selectedCard, setSelectedCard] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [IpLastLog, setIpLastLog] = useState();
  const ListProductsHome = useSelector((state) => state.miga.listProductsHome);
  const ProductSelct = useSelector((state) => state.miga.ProductSelect);
  const dataAlert = useSelector((state) => state.miga.Alert);
  const getCookie = (name) => {
    let matches = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
          '=([^;]*)'
      )
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  // Lógica movimientos y productos

  const shortcutAccount = [
    {
      icon: 'fas fa-exchange-alt text-secondary',
      icon: iconTransfer,
      iconactiv: iconTransferVerde,
      title: 'Transferir',
      path: '/admin/transfers',
    },
    {
      icon: iconDetails,
      iconactiv: iconDetailsVerde,
      title: 'Detalles',
      path: '/admin/product/account-movements',
    },
  ];

  const shortcutCdt = [
    {
      icon: iconDetails,
      iconactiv: iconDetailsVerde,
      title: 'Detalles',
      path: '/admin/product/cdt-movements',
    },
  ];

  const shortcutLoan = [
    {
      icon: iconProyect,
      iconactiv: iconProyectVerde,
      title: 'Proyectar',
      path: '/admin/Proyeccion',
    },

    {
      icon: iconDetails,
      iconactiv: iconDetailsVerde,
      title: 'Detalles',
      path: '/admin/product/loan-movements',
    },
  ];
  const dispatch = useDispatch();
  var createReactClass = require('create-react-class');

  useEffect(() => {
    const perfilCookie = getCookie('TEMPORAL');
    let permitido = false;

    if (perfilCookie) {
      for (let i = 0; i < perfiles.length; i++) {
        if (
          perfiles[i].nombrePerfil == 'Preparador' ||
          perfiles[i].nombrePerfil == 'Estándar' ||
          perfiles[i].nombrePerfil == 'Aprobador' ||
          perfiles[i].nombrePerfil == 'Seguridad'
        ) {
          if (
            perfilCookie.substring(1, 2) == '1' ||
            perfilCookie.substring(3, 4) == '1'
          ) {
            permitido = true;
          } else {
            permitido = false;
          }
          i = perfiles.length;
        }
      }
    } else {
      permitido = false;
    }
    if (permitido) {
      let copiapermisos = _.cloneDeep(permisos);

      for (let i = 0; i < copiapermisos.length; i++) {
        if (copiapermisos[i].title == 'Transferir') {
          copiapermisos[i].habil = true;

          i = copiapermisos.length;
        }
      }
      setpermisos(_.cloneDeep(copiapermisos));
    }
    let shortCutAux = [];

    shortcutAccount.map((item, index) => {
      //shortCutAccountFilter
      // if (permitido) {
      //   shortCutAux.push(item);
      // } else {
      if (item.title != 'Transferir') {
        shortCutAux.push(item);
      }
      // }
    });

    setShortCutAccountFilter(shortCutAux);
    setDateLastLog(fechaingresoredux);
    setIpLastLog(ipredux);
    dispatch(cambiaruta('Inicio'));

    dispatch(cambiasidebar(false));

    dispatch(opcadmnav(''));

    window.addEventListener('resize', resize.bind(this));

    resize();

    async function getProducts() {
      const request = await axiosInstance()
        .get('/WSGYG39_2/api/Inquiries/Products')
        .catch((err) => {
          return 'err';
        });

      if (request != 'err') {
        setDateLastLog(request.data.dateLastLog);
        setTotalBalanceAccounts(
          request.data.summaryProducts.totalBalanceAccounts
        );
        setTotalBalanceCredit(request.data.summaryProducts.totalBalanceCredit);
        setTotalBalanceCDTs(request.data.summaryProducts.totalBalanceCDTs);
        setList(request.data.summaryProducts.products);
        getMovementsAsync(request.data.summaryProducts.products[0]);
        const totalBalance = {
          balanceCredit: request.data.summaryProducts.totalBalanceCredit,
          balanceCdts: request.data.summaryProducts.totalBalanceCDTs,
          balanceAccounts: request.data.summaryProducts.totalBalanceAccounts,
        };
        dispatch(
          actualizaIpyfecha({
            ip: request.data.ipLastLog,
            fchingreso: request.data.dateLastLog,
            nombreCliente: request.data.clientName,
          })
        );
        dispatch(actualizarProducts(request.data));
        dispatch(actualizaBalanceTotal(totalBalance));
      }
      return request;
    }
    getProducts();
    async function getMovementsAsync(product) {
      setProduct(product);
      setIsLoading(false);
    }
  }, []);

  function resize() {
    if (window.innerWidth <= 2500 && window.innerWidth > 1800) {
      setSett({ ...sett, slidesToShow: 2 });
    } else if (window.innerWidth <= 1800 && window.innerWidth > 1000) {
      setSett({ ...sett, slidesToShow: 2 });
    } else if (window.innerWidth <= 1000 && window.innerWidth > 576) {
      setSett({ ...sett, slidesToShow: 2 });
    } else if (window.innerWidth <= 576) {
      setSett({ ...sett, slidesToShow: 1 });
    }
  }

  function getMovements(product) {
    //setIsMovementLoading(true);
    setProduct(product);
  }

  const Alerts = (props) => {
    var data = props.data;
    var newsTemplate;
    if (data.length > 0) {
      newsTemplate = data.map(function (item, index) {
        return (
          <div class={item.type} role="alert">
            <button
              type="button"
              class="close"
              aria-label="Close"
              onClick={() => deleteAlert(item)}
            >
              <span aria-hidden="true">×</span>
            </button>
            <span className="alert-inner--icon mr-3">
              <i className={item.icon} />
            </span>{' '}
            <span class="alert-inner--text">{item.description}</span>
          </div>
        );
      });
    }
    return <div className="toast-bottom-right">{newsTemplate}</div>;
  };

  const deleteAlert = (alert) => {
    dispatch(actualizaAlert(dataAlert.filter((auxAlert) => auxAlert != alert)));
  };
  const deleteTimeAlert = () => {
    setTimeout(function () {
      dispatch(actualizaAlert([]));
    }, 4000);
  };
  var Movement = createReactClass({
    render: function () {
      var Date = this.props.data.transactionDate.substring(5, 10),
        DateYear = this.props.data.transactionDate.substring(0, 4),
        Description = this.props.data.transactionName,
        Account = product.accountNumber,
        Value = this.props.data.transactionBalance,
        color =
          this.props.data.sign === '' || this.props.data.sign === undefined
            ? 'text-grissantander'
            : this.props.data.sign === '+'
            ? 'text-green'
            : 'text-primary';

      return (
        <div className="card-transaction-info ml-5 mr-5">
          <Row style={{ alignItems: 'center' }}>
            <div
              className="col-auto mr-3 text-medium-grey"
              style={{ alignItems: 'center' }}
            >
              <p style={{ marginBottom: 0, fontSize: '12px' }}>
                {Date}

                <br />

                {DateYear}
              </p>
            </div>

            <div className="col">
              <Row>
                <div
                  style={{
                    display: 'flex',

                    alignItems: 'center',

                    marginLeft: 10 + 'px',
                  }}
                >
                  <p
                    style={{
                      fontWeight: 400,
                      margin: '2px 0 0 0px',
                      fontSize: '12px',
                    }}
                  >
                    {Description}
                  </p>
                </div>
              </Row>

              <Row>
                <span
                  style={{ marginBottom: 0, marginLeft: '10px' }}
                  class="mb-2 text-sm"
                >
                  {Account}
                </span>
              </Row>
            </div>

            <div className="col-auto mr-3 vertical-center">
              <h6
                style={{
                  fontWeight: 400,

                  fontSize: 1 + 'rem',

                  marginBottom: 0,
                }}
                className={color}
              >
                <i className="fas fa-dollar-sign" />

                {Value}

                <span class="decimal-numbers-format"></span>
              </h6>
            </div>
          </Row>
        </div>
      );
    },
  });

  var Movements = createReactClass({
    render: function () {
      var data = this.props.data;

      var newsTemplate;

      var title;

      if (data != null) {
        if (isMovementLoading) {
          newsTemplate = (
            <div>
              <Skeleton
                height={80}
                count={4}
                className="card-transaction-info"
                style={{ width: '-webkit-fill-available' }}
              ></Skeleton>
            </div>
          );
        } else {
          newsTemplate = data.slice(0, 4).map(function (item, index) {
            return (
              <div key={index}>
                <Movement data={item} />
              </div>
            );
          });
        }
      } else {
        newsTemplate = <p>Hoy no se han generado movimientos</p>;
      }

      if (product.accountNumber === undefined) title = '';
      else
        title = (
          <h1
            className="text-gray-dark mb-3"
            style={{ 'padding-left': '45px', fontSize: '20px' }}
          >
            Movimientos Producto Número: {product.accountNumber}
          </h1>
        );

      return (
        <div>
          {title}

          {newsTemplate}
        </div>
      );
    },
  });

  var ShortCuts = createReactClass({
    render: function () {
      var product = this.props.data;

      var newsTemplate;

      if (product != null) {
        if (!isMovementLoading) {
          var vec = shortcutAccount;

          if (product.accountType === '2' || product.accountType === '6') {
            vec = shortcutLoan;
          } else if (product.accountType === '7') {
            vec = shortcutCdt;
          }

          //<Col style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"flex-start"}} key={index} >

          newsTemplate = vec.map(function (item, index) {
            return <ShortCut data={item} key={index} />;
          });
        } else {
          newsTemplate = (
            <>
              <Col xl="2" md="4" sm="12" className="">
                <Skeleton height={100} className="card-fast-actions"></Skeleton>
              </Col>

              <Col xl="2" md="4" sm="12" className="">
                <Skeleton height={100} className="card-fast-actions"></Skeleton>
              </Col>

              <Col xl="2" md="4" sm="12" className="">
                <Skeleton height={100} className="card-fast-actions"></Skeleton>
              </Col>

              <Col xl="2" md="4" sm="12" className="">
                <Skeleton height={100} className="card-fast-actions"></Skeleton>
              </Col>
            </>
          );
        }
      } else {
        newsTemplate = <p>Hoy no se han generado movimientos</p>;
      }

      //return <Row className="mt-1">{newsTemplate}</Row>;

      return (
        <Col
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}
        >
          {newsTemplate}
        </Col>
      );
    },
  });

  var ShortCut = createReactClass({
    render: function () {
      var icon = this.props.data.icon,
        title = this.props.data.title,
        path = this.props.data.path,
        state = this.props.data.state;

      return (
        <NavLink
          to={{
            pathname: path,

            state: {
              accountNumber: product.accountNumber,

              accountType: product.accountType,

              system: product.system,
            },
          }}
          tag={NavLinkRRD}
          activeClassName="active"
        >
          <div
            className="card-fast-actions bg-green"
            style={{ 'max-width': '50%' }}
          >
            <CardBody style={{ padding: '1em' }}>
              <Row className="align-items-center">
                <Col className="col-auto">
                  <div
                    className="icon icon-shape text-white rounded-circle shadow"
                    style={{ width: '40px', height: '40px' }}
                  >
                    {/*<i className={icon} />*/}

                    <i>
                      <img style={{ height: '40px' }} src={icon}></img>
                    </i>
                  </div>
                </Col>

                <div className="col ">
                  <CardTitle
                    tag="h5"
                    className="text-white mb-0"
                    style={{ fontSize: '10px' }}
                  >
                    {title}
                  </CardTitle>
                </div>
              </Row>
            </CardBody>
          </div>
        </NavLink>
      );
    },
  });
  const getProductSelect = (productSelect, i) => {
    let productListSelect = [];
    setProduct(productSelect);
    if (i != null) {
      ProductSelct.map((item, index) => {
        if (i === index) {
          productListSelect.push(true);
        } else {
          productListSelect.push(false);
        }
      });
      dispatch(actualizaProductSelect(productListSelect));
    }
  };

  if (isLoading) {
    return (
      <>
        <div className="pb-2 pt-5 pt-md-7 ml-lg-4 mr-lg-5">
          <Row>
            <Col xl="2" md="12" sm="12">
              <Skeleton height={200} className="card-carousel"></Skeleton>
            </Col>

            <Col xl="2" md="12" sm="12">
              <Skeleton height={200} className="card-carousel"></Skeleton>
            </Col>

            <Col xl="2" md="12" sm="12">
              <Skeleton height={200} className="card-carousel"></Skeleton>
            </Col>

            <Col xl="2" md="12" sm="12">
              <Skeleton height={200} className="card-carousel"></Skeleton>
            </Col>

            <Col xl="4" md="12" sm="12" className="mt-4">
              <Skeleton
                height={80}
                count={2}
                className="card-stats shadow mt-2 m-1"
              ></Skeleton>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col xl="8" md="12" sm="12">
              <Skeleton
                height={20}
                className="card-transaction-info"
                style={{ width: '-webkit-fill-available' }}
              ></Skeleton>

              <Skeleton
                height={100}
                count={5}
                className="card-transaction-info"
                style={{ width: '-webkit-fill-available' }}
              ></Skeleton>
            </Col>

            <Col xl="4" md="12" sm="12" className="mt-lg-5">
              <Skeleton
                height={200}
                count={2}
                className="responsive-banner mb-2 mt-2"
              ></Skeleton>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col xl="2" md="4" sm="12" className="">
              <Skeleton height={100}></Skeleton>
            </Col>

            <Col xl="2" md="4" sm="12" className="">
              <Skeleton height={100}></Skeleton>
            </Col>

            <Col xl="2" md="4" sm="12" className="">
              <Skeleton height={100}></Skeleton>
            </Col>

            <Col xl="2" md="4" sm="12" className="">
              <Skeleton height={100}></Skeleton>
            </Col>
          </Row>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="pb-2 pt-3 pt-md-6 ml-lg-4 mr-lg-5">
          <Row>
            <Carruselproductos
              setFilterData={setFilterData}
              setSelectedCard={setSelectedCard}
              listProducts={ListProducts}
              sett={sett}
              getMovements={getMovements}
              deleteTimeAlert={deleteTimeAlert}
              getProductSelect={getProductSelect}
            ></Carruselproductos>
          </Row>
          <Row>
            <Movimientoshome
              product={product}
              shortcutAccount={shortCutAccountFilter}
              shortcutLoan={shortcutLoan}
              shortcutCdt={shortcutCdt}
              getProductSelect={getProductSelect}
            ></Movimientoshome>
          </Row>
          <Alerts data={dataAlert}></Alerts>
        </div>
      </>
    );
  }
}

export default Home;
